export default "__VITE_ASSET__CTPW8zk3__"